import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './inbound.actions.js';
import getters from './inbound.getters.js';
import mutations from './inbound.mutations.js';
import state from './inbound.state.js';

BaseStore.registerModule('inboundTransmissionsInspection', {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
});
export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('inboundTransmissionsInspection');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
